import React from 'react';
import { Link } from 'react-router-dom';
import { Check, Clock, Calendar, Target } from 'lucide-react';
export function Fall2026() {
  return <div className="w-full" data-id="element-419" data-mp="2lin73ryr2mme">
      <Hero data-id="element-420" data-mp="2pm1z7gzyqtg7" />
      <LocationBanner data-id="element-421" data-mp="2pmbhsjiohybv" />
      <IntroSection data-id="element-422" data-mp="2pn4oxlljupuj" />
      <ProgramsAndSchedule data-id="element-423" data-mp="2pml5g0g93tee" />
      <WeekAtAGlance data-id="element-424" data-mp="2pk8tc3x6cd99" />
      <TwoTracks data-id="element-425" data-mp="2uloctrjpebpj" />
      <TestingAndCalendar data-id="element-426" data-mp="2uk3hw0th8qr5" />
      <MembershipIncludes data-id="element-427" data-mp="2ukmr8t52a6tk" />
      <FinalCta data-id="element-428" data-mp="2uisbdt8nd4wc" />
    </div>;
}
/* ---------- HERO ---------- */
function Hero() {
  return <section className="relative bg-reach-black overflow-hidden py-20 md:py-28" data-id="element-429" data-mp="1xt2nr7yopncl">
      <div className="absolute inset-0 z-0" data-id="element-430" data-mp="21wqu5nbkycw9">
        <img src="https://images.unsplash.com/photo-1517649763962-0c623066013b?q=80&w=2400&auto=format&fit=crop" alt="Athletes training on indoor turf" className="w-full h-full object-cover grayscale contrast-125 opacity-60" data-id="element-431" data-mp="26v22tuq52hcw" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/85 via-black/70 to-black/90" data-id="element-432" data-mp="1e528uqx6eoot" />
        <div className="absolute inset-0 bg-reach-red mix-blend-multiply opacity-[0.08]" data-id="element-433" data-mp="1j3my5vaw3nyh" />
      </div>

      <div className="absolute inset-0 z-10 pointer-events-none overflow-hidden" data-id="element-434" data-mp="3gf3urdtat1r7">
        <div className="absolute top-1/3 -left-40 w-[55%] h-2 bg-reach-red transform -rotate-[7deg] opacity-50" data-id="element-435" data-mp="3cch8dsfec91e" />
        <div className="absolute top-[44%] -left-40 w-[40%] h-2 bg-reach-red transform -rotate-[7deg] opacity-30" data-id="element-436" data-mp="37imkecsrd7wi" />
        <div className="absolute top-[55%] -left-40 w-[28%] h-2 bg-reach-red transform -rotate-[7deg] opacity-20" data-id="element-437" data-mp="2xmjin81tjba3" />
      </div>

      <div className="relative z-20 max-w-container mx-auto px-4 md:px-8 text-center" data-id="element-438" data-mp="2smndh5hdxdsy">
        <p className="font-inter text-reach-red text-xs md:text-sm uppercase tracking-[0.3em] font-semibold mb-5" data-id="element-439" data-mp="2ollemprdr3ri">
          Fall Season . August 11 to December 17
        </p>
        <h1 className="font-bebas text-white text-[56px] sm:text-7xl md:text-8xl lg:text-[120px] leading-[0.9] tracking-wide mb-5" data-id="element-440" data-mp="muqbfcuug2ar">
          Fall Training Schedule
        </h1>
        <p className="font-inter text-white/85 text-base md:text-xl max-w-2xl mx-auto leading-relaxed" data-id="element-441" data-mp="htkibdx9ud0p">
          The school year is where summer work pays off. Four groups on Tuesday
          and Thursday nights, built around the fall sports calendar, plus a new
          daytime group for homeschool athletes.
        </p>
      </div>
    </section>;
}
/* ---------- LOCATION BANNER ---------- */
function LocationBanner() {
  return <section className="bg-reach-red" data-id="element-442" data-mp="1knq2oumo6cav">
      <div className="max-w-container mx-auto px-4 md:px-8 py-4 md:py-5" data-id="element-443" data-mp="1korbstk4kopy">
        <p className="font-inter text-white text-center text-xs md:text-sm uppercase tracking-[0.25em] font-semibold" data-id="element-444" data-mp="1ootff89f7s7v">
          Inside INPOWERiQ . 6051 Alma Rd . McKinney TX 75070 . Tuesdays and
          Thursdays
        </p>
      </div>
    </section>;
}
/* ---------- INTRO SECTION ---------- */
function IntroSection() {
  return <section className="bg-white py-16 md:py-20" data-id="element-445" data-mp="3vidpo41pqhxa">
      <div className="max-w-3xl mx-auto px-4 md:px-8 text-center" data-id="element-446" data-mp="4a9lv3p7nh38">
        <p className="font-inter text-reach-black text-lg md:text-xl leading-relaxed" data-id="element-447" data-mp="3svuueslgb4r0">
          Fall training runs Tuesday and Thursday at INPOWERiQ Performance
          Center. High school athletes now train by track. Court athletes and
          field athletes have different demands, so each group trains what its
          sports actually ask for. In-season athletes train around their match
          schedule, not through it.
        </p>
      </div>
    </section>;
}
/* ---------- PROGRAMS AND SCHEDULE ---------- */
const PROGRAMS = [{
  title: 'Homeschool Multisport',
  eyebrow: 'Homeschool Athletes . New for Fall',
  duration: '90 minute sessions',
  schedule: ['Tue and Thu 2:30 to 4:00 PM'],
  note: 'Your athletic period. Founding rate $325 through Aug 9, then $400 per month. Capped at 10.',
  isNew: true
}, {
  title: 'Performance Prep',
  eyebrow: 'Middle School . Ages 11 to 13',
  duration: '60 minute sessions',
  schedule: ['Tue and Thu 4:45 to 5:45 PM'],
  note: 'Move-ups to Advanced by coach invite.',
  isNew: false
}, {
  title: 'Advanced . Court',
  eyebrow: 'High School . Ages 14+',
  duration: '75 minute sessions',
  schedule: ['Tue and Thu 5:45 to 7:00 PM'],
  note: 'Basketball and volleyball athletes.',
  isNew: false
}, {
  title: 'Advanced . Field',
  eyebrow: 'High School . Ages 14+',
  duration: '75 minute sessions',
  schedule: ['Tue and Thu 7:00 to 8:15 PM'],
  note: 'Soccer, baseball, lacrosse, and football athletes.',
  isNew: false
}];
function ProgramsAndSchedule() {
  return <section className="bg-reach-gray py-20 md:py-28" data-id="element-448" data-mp="3rtpbukeohdem">
      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-449" data-mp="3ru8kfaifupfz">
        <div className="text-center mb-14" data-id="element-450" data-mp="nxo1rodicuz">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-451" data-mp="mmm7xehnf6i">
            Programs and Class Times
          </p>
          <h2 className="font-bebas text-4xl md:text-6xl tracking-wide" data-id="element-452" data-mp="22e97rjfm2hvl">
            Choose Your Group
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-453" data-mp="jl7lwq8op7gc">
          {PROGRAMS.map(program => <div key={program.title} className="relative bg-white rounded-[4px] p-7 border-b-4 border-transparent hover:border-reach-red transition-colors" data-id="element-454" data-mp="eqtm8bmzoe5v">
              {program.isNew && <span className="absolute top-4 right-4 bg-reach-red text-white font-inter text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded-[4px]" data-id="element-455" data-mp="12i8wqrox61s7">
                  New
                </span>}
              <p className="font-inter text-reach-red text-xs uppercase tracking-[0.25em] font-semibold mb-3" data-id="element-456" data-mp="tgrhtcn90653">
                {program.eyebrow}
              </p>
              <h3 className="font-bebas text-3xl tracking-wide leading-none mb-4" data-id="element-457" data-mp="3e81lqzrhyio9">
                {program.title}
              </h3>
              <div className="flex items-center gap-2 mb-5 text-sm font-inter text-reach-black/70" data-id="element-458" data-mp="397x61byexrz3">
                <Clock size={14} className="text-reach-red" data-id="element-459" data-mp="3ar6zw3xlu7wt" />
                <span className="uppercase tracking-wider" data-id="element-460" data-mp="3fp8jcpyy098t">
                  {program.duration}
                </span>
              </div>
              <div className="border-t border-black/10 pt-4" data-id="element-461" data-mp="31oe87zkifu6g">
                <p className="font-inter text-xs uppercase tracking-[0.25em] text-reach-black/60 mb-3" data-id="element-462" data-mp="36oa93pxwv5hs">
                  Weekly Schedule
                </p>
                <ul className="space-y-2 mb-4" data-id="element-463" data-mp="2rybefx5kec72">
                  {program.schedule.map(slot => <li key={slot} className="font-inter text-sm font-semibold text-reach-black" data-id="element-464" data-mp="2wrns5c8pgyl1">
                      {slot}
                    </li>)}
                </ul>
                <p className="font-inter text-sm text-reach-black/70 leading-relaxed" data-id="element-465" data-mp="290i9yqfalu7k">
                  {program.note}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
/* ---------- WEEK AT A GLANCE ---------- */
function WeekAtAGlance() {
  const schedule = [{
    time: '2:30 to 4:00 PM',
    tue: 'HOMESCHOOL MULTISPORT',
    thu: 'HOMESCHOOL MULTISPORT'
  }, {
    time: '4:45 to 5:45 PM',
    tue: 'PERFORMANCE PREP 11 to 13',
    thu: 'PERFORMANCE PREP 11 to 13'
  }, {
    time: '5:45 to 7:00 PM',
    tue: 'ADVANCED . COURT 14+',
    thu: 'ADVANCED . COURT 14+'
  }, {
    time: '7:00 to 8:15 PM',
    tue: 'ADVANCED . FIELD 14+',
    thu: 'ADVANCED . FIELD 14+'
  }];
  return <section className="bg-white py-20 md:py-28" data-id="element-466" data-mp="2n1p75tam18xy">
      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-467" data-mp="2n4l71n60q7p1">
        <div className="text-center mb-12" data-id="element-468" data-mp="2i4yrv86mqhdl">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-469" data-mp="2w3eyz08em9w9">
            The Week at a Glance
          </p>
          <h2 className="font-bebas text-4xl md:text-6xl tracking-wide" data-id="element-470" data-mp="2s34r1i11x9er">
            Full Schedule
          </h2>
        </div>

        <div className="overflow-x-auto max-w-4xl mx-auto" data-id="element-471" data-mp="2dhr3q10bvrn">
          <table className="w-full min-w-[480px] border-collapse" data-id="element-472" data-mp="79fay6bhbk96">
            <thead data-id="element-473" data-mp="c9umqtg44jp1">
              <tr className="bg-reach-black text-white" data-id="element-474" data-mp="c9bantd58pix">
                <th className="font-bebas text-lg tracking-wider uppercase text-left p-4 border-r border-white/10" data-id="element-475" data-mp="c7qksh1rxure">
                  Time
                </th>
                <th className="font-bebas text-lg tracking-wider uppercase p-4 border-r border-white/10" data-id="element-476" data-mp="3frl88uzu101p">
                  Tuesday
                </th>
                <th className="font-bebas text-lg tracking-wider uppercase p-4" data-id="element-477" data-mp="3or88vekqm1tp">
                  Thursday
                </th>
              </tr>
            </thead>
            <tbody data-id="element-478" data-mp="3tizs141kd59t">
              {schedule.map((row, i) => <tr key={row.time} className={i % 2 === 0 ? 'bg-reach-gray' : 'bg-white'} data-id="element-479" data-mp="2wyr1upg9yg93" data-mpi={i}>
                  <td className="font-inter text-sm font-semibold text-reach-black p-4 border-r border-black/5" data-id="element-480" data-mp="30z153ucomsk9">
                    {row.time}
                  </td>
                  <td className="font-inter text-xs uppercase tracking-wider text-reach-black/80 text-center p-4 border-r border-black/5" data-id="element-481" data-mp="2ok30ub33q158">
                    {row.tue}
                  </td>
                  <td className="font-inter text-xs uppercase tracking-wider text-reach-black/80 text-center p-4" data-id="element-482" data-mp="2fhbom92ej1cj">
                    {row.thu}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <p className="font-inter text-center text-sm text-reach-black/60 mt-8 max-w-2xl mx-auto" data-id="element-483" data-mp="20t76b679grua">
          Tuesday and Thursday to start. A Monday and Wednesday block opens as
          groups fill.
        </p>
      </div>
    </section>;
}
/* ---------- TWO TRACKS ---------- */
function TwoTracks() {
  return <section className="bg-reach-black text-white py-20 md:py-28 relative overflow-hidden" data-id="element-484" data-mp="1mswdhxme536h">
      <div className="absolute -right-40 top-1/4 w-[50%] h-1 bg-reach-red opacity-30 rotate-[6deg]" data-id="element-485" data-mp="2k4um1ngy1qxz" />
      <div className="absolute -right-40 top-[34%] w-[35%] h-1 bg-reach-red opacity-20 rotate-[6deg]" data-id="element-486" data-mp="2g40wyqrrm63i" />

      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-487" data-mp="2tvffkwhrg5a1">
        <div className="text-center mb-12" data-id="element-488" data-mp="2tx0e0x7748d6">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-489" data-mp="2ovjcr0ksujw2">
            Advanced Performance
          </p>
          <h2 className="font-bebas text-5xl md:text-6xl tracking-wide leading-none mb-4" data-id="element-490" data-mp="218b9eo6xlkwo">
            Two Tracks.
            <br data-id="element-491" data-mp="2b4ekijjrgtvr" />
            One System.
          </h2>
          <p className="font-inter text-white/85 text-lg md:text-xl max-w-2xl mx-auto" data-id="element-492" data-mp="2b5zf2962sctm">
            Court sports and field sports load the body differently. Your
            athlete trains what their sport actually asks for.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto" data-id="element-493" data-mp="3hkqiokml2brc">
          <div className="bg-white/[0.04] border border-white/10 rounded-[4px] p-8" data-id="element-494" data-mp="13cz4h5gdrmpb">
            <h3 className="font-bebas text-2xl md:text-3xl tracking-wide mb-2 text-reach-red" data-id="element-495" data-mp="13f23gezigq66">
              Court Track
            </h3>
            <p className="font-inter text-xs uppercase tracking-[0.25em] text-white/60 mb-6" data-id="element-496" data-mp="ucsx81b9ziyl">
              Basketball . Volleyball
            </p>
            <ul className="space-y-3" data-id="element-497" data-mp="zd87gk09gacc">
              {['Jump and landing mechanics', 'Change of direction in tight spaces', 'Vertical power development', 'Strength by tier, earned not assigned'].map(item => <li key={item} className="flex items-start gap-3" data-id="element-498" data-mp="1d8sqdffzosjr">
                  <Check size={16} className="text-reach-red shrink-0 mt-1" data-id="element-499" data-mp="1i8ourfslmlzu" />
                  <span className="font-inter text-sm text-white/85" data-id="element-500" data-mp="25z12oqnugiqf">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="bg-white/[0.04] border border-white/10 rounded-[4px] p-8" data-id="element-501" data-mp="2kmsyxh23nskn">
            <h3 className="font-bebas text-2xl md:text-3xl tracking-wide mb-2 text-reach-red" data-id="element-502" data-mp="2fn6jr22po297">
              Field Track
            </h3>
            <p className="font-inter text-xs uppercase tracking-[0.25em] text-white/60 mb-6" data-id="element-503" data-mp="2an25lip9zjm5">
              Soccer . Baseball . Lacrosse . Football
            </p>
            <ul className="space-y-3" data-id="element-504" data-mp="21n594uwn9ggj">
              {['Acceleration and top speed', 'Cutting and curved running at pace', 'Posterior chain strength', 'In-season load management'].map(item => <li key={item} className="flex items-start gap-3" data-id="element-505" data-mp="1rv993eazzg9o">
                  <Check size={16} className="text-reach-red shrink-0 mt-1" data-id="element-506" data-mp="1n02ceqg5bbu9" />
                  <span className="font-inter text-sm text-white/85" data-id="element-507" data-mp="1hycyn31jgk2h">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="font-inter text-white/70 text-base text-center mt-10 max-w-2xl mx-auto" data-id="element-508" data-mp="3pk4pq3rkgjjg">
          In-season athletes train around their match schedule, not through it.
          Every session still starts with speed and power.
        </p>
      </div>
    </section>;
}
/* ---------- TESTING AND CALENDAR ---------- */
function TestingAndCalendar() {
  const testDates = [{
    label: 'Aug 11',
    sub: 'Baseline'
  }, {
    label: 'Oct 6',
    sub: 'Retest'
  }, {
    label: 'Dec 15',
    sub: 'Final'
  }];
  return <section className="bg-white py-20 md:py-28" data-id="element-509" data-mp="3fvmstxmeqwl3">
      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-510" data-mp="3fts74h3bb0fy">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-511" data-mp="3kmlc962p0ask">
          {/* Performance Testing */}
          <div className="bg-reach-gray rounded-[4px] p-8 md:p-10 border-l-4 border-reach-red" data-id="element-512" data-mp="2n7h3syobmlfg">
            <div className="flex items-center gap-3 mb-4" data-id="element-513" data-mp="2s50k044kx8a1">
              <Target size={24} className="text-reach-red" data-id="element-514" data-mp="2s3fskndka5ge" />
              <h3 className="font-bebas text-2xl md:text-3xl tracking-wide uppercase leading-none" data-id="element-515" data-mp="xq3ibte8d39h">
                Performance Testing . Every 4 Weeks
              </h3>
            </div>
            <p className="font-inter text-reach-black text-base leading-relaxed mb-6" data-id="element-516" data-mp="17gev85fw6msi">
              Three testing windows across the fall. Same markers each time so
              progress is measured, not guessed at.
            </p>
            <div className="flex items-center justify-between gap-4 mb-6" data-id="element-517" data-mp="1hfnnmtv3ztcr">
              {testDates.map(date => <div key={date.label} className="text-center" data-id="element-518" data-mp="1qe92adxgmo89">
                  <p className="font-bebas text-3xl md:text-4xl text-reach-red tracking-wide leading-none mb-1" data-id="element-519" data-mp="1qdpnh633wfyg">
                    {date.label}
                  </p>
                  <p className="font-inter text-xs uppercase tracking-[0.2em] text-reach-black/70" data-id="element-520" data-mp="3s4sznzsna2l4">
                    {date.sub}
                  </p>
                </div>)}
            </div>
            <p className="font-inter text-sm text-reach-black/70 leading-relaxed italic" data-id="element-521" data-mp="22pi8hqqqozpo">
              We test 10 yard, flying 10, 5-10-5 shuttle, vertical jump, and
              broad jump. The same foundational markers used in high level
              performance programs.
            </p>
          </div>

          {/* Fall Calendar */}
          <div className="bg-reach-gray rounded-[4px] p-8 md:p-10 border-l-4 border-reach-red" data-id="element-522" data-mp="1xvntv1pzraxg">
            <div className="flex items-center gap-3 mb-4" data-id="element-523" data-mp="1k0277178d387">
              <Calendar size={24} className="text-reach-red" data-id="element-524" data-mp="1oy3rfpge78l9" />
              <h3 className="font-bebas text-2xl md:text-3xl tracking-wide uppercase leading-none" data-id="element-525" data-mp="1axkhudwa3ugz">
                Fall Calendar
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-526" data-mp="1ez60kfvhv2z3">
              {['Season starts Tuesday, August 11, right as McKinney, Frisco, and Allen head back to school.', 'No sessions Thanksgiving week, November 24 and 26.', 'Season ends Thursday, December 17, before winter break.', 'Aligned with the McKinney, Frisco, and Allen ISD calendars.'].map(item => <li key={item} className="flex items-start gap-3" data-id="element-527" data-mp="d3rzt4lw35kd">
                  <Check size={16} className="text-reach-red shrink-0 mt-1" strokeWidth={3} data-id="element-528" data-mp="d41numndj2nf" />
                  <span className="font-inter text-base text-reach-black leading-relaxed" data-id="element-529" data-mp="14twh2uecrchd">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}
/* ---------- MEMBERSHIP INCLUDES ---------- */
const INCLUDES = ['Access to the on-site recovery zone after every session.', 'Performance testing every 4 weeks across the fall.', 'Speed gates and jump mat testing for real progress data.', 'Periodized programming, never random workouts.', 'Capped small group training for individualized coaching.', 'Integrated speed and strength every session.'];
function MembershipIncludes() {
  return <section className="bg-reach-gray py-20 md:py-24" data-id="element-530" data-mp="1w394ce7hzdb2">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-531" data-mp="211sms4mvu6yo">
        <div className="text-center mb-10" data-id="element-532" data-mp="21096wf551xxf">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-533" data-mp="252w12mpa7uxs">
            Every Membership Includes
          </p>
          <h2 className="font-bebas text-4xl md:text-5xl tracking-wide leading-none" data-id="element-534" data-mp="2a1z09qikz6xu">
            What's Included
          </h2>
        </div>
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-white rounded-[4px] p-6 md:p-8 border-l-4 border-reach-red" data-id="element-535" data-mp="2jrihysuk4ur4">
          {INCLUDES.map(item => <li key={item} className="flex items-start gap-3" data-id="element-536" data-mp="2ot7te9lozafq">
              <div className="w-6 h-6 bg-reach-red rounded-sm flex items-center justify-center shrink-0 mt-0.5" data-id="element-537" data-mp="2su1j98ip2zb9">
                <Check size={14} className="text-white" strokeWidth={3} data-id="element-538" data-mp="2xscr5dpfizqu" />
              </div>
              <span className="font-inter text-reach-black text-base" data-id="element-539" data-mp="3j1gtq8vokm8t">
                {item}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}
/* ---------- FINAL CTA ---------- */
function FinalCta() {
  return <section className="bg-reach-red py-16 md:py-20" data-id="element-540" data-mp="3o24hmlom4myt">
      <div className="max-w-container mx-auto px-4 md:px-8 text-center" data-id="element-541" data-mp="3o2mjpyxyhven">
        <h2 className="font-bebas text-white text-5xl md:text-7xl tracking-wide mb-4" data-id="element-542" data-mp="30dbqr3mul5b2">
          Reserve Your Fall Spot.
        </h2>
        <p className="font-inter text-white text-lg md:text-xl mb-10 max-w-2xl mx-auto" data-id="element-543" data-mp="2vb2w82ubtv6u">
          Groups are capped. When a slot fills, it fills.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-stretch sm:items-center max-w-md sm:max-w-none mx-auto" data-id="element-544" data-mp="35abxlgriuc38">
          <Link to="/pricing" className="inline-flex items-center justify-center bg-white text-reach-black font-inter font-semibold px-6 min-h-[44px] md:min-h-[48px] rounded-[4px] transition-all duration-200 ease-out hover:bg-reach-black hover:text-white uppercase tracking-wide text-sm md:text-base hover:-translate-y-[3px]" data-id="element-545" data-mp="2hjy0hbu2xn1s">
            Enroll Now
          </Link>
          <Link to="/book" className="btn-secondary-dark sm:w-auto" data-id="element-546" data-mp="i4ee9s9x54sj">
            Book Free Consultation
          </Link>
        </div>
      </div>
    </section>;
}